import Appsignal from '@appsignal/javascript';

export const appsignal = new Appsignal({ key: APPSIGNAL_PUSH_KEY });
